import { HTMLAttributes } from "react";
import { cn } from "@/utils";

export const Skeleton = ({
  className,
  ...props
}: HTMLAttributes<HTMLDivElement>) => {
  return (
    <div
      className={cn("bg-surface-tertiary animate-pulse rounded-md", className)}
      {...props}
    />
  );
};
